import React, { useEffect } from 'react'

import { isEmpty } from 'lodash'
import { Box, Button, Grid } from '@material-ui/core'
import { useParams, useLocation } from 'react-router-dom'
import { FormContext, useForm } from 'react-hook-form'

import {
  DocumentStep,
  DocumentStepSkeleton,
  EmailStep,
  EmailStepSkeleton,
  InvalidLinkScreen,
  TwoFactorAuthenticationStep,
  TwoFactorAuthenticationStepSkeleton,
} from './components'

import useSupplierJourney from 'hooks/useSupplierJourney'

import constants from 'constants/index'
import helpers from 'helpers'
import {
  documentStepSchema,
  emailStepSchema,
  twoFactorAuthenticationStepSchema,
} from './schema'

const Journey = () => {
  const { slug, token } = useParams()

  const location = useLocation()
  const document = new URLSearchParams(location.search).get('document')

  const {
    activeStep,
    linkInvalid,
    loadDataWithAnimation,
    loaded,
    nextDisabled,
    recaptcha,
    setStepInfo,
    setSteps,
    setNextDisabled,
    stepInfo,
    steps,
    supplier,
    company,
    international,
  } = useSupplierJourney()

  const isFirstAccess = supplier?.firstAccess

  const schemas = [
    documentStepSchema(international),
    emailStepSchema(isFirstAccess),
    twoFactorAuthenticationStepSchema,
  ]

  const formMethods = useForm({
    validationSchema: schemas[activeStep],
    defaultValues: {
      document: document || '',
      name: '',
      email: '',
      code: '',
    },
  })

  const { reset } = formMethods

  const isFinalStep = activeStep === steps.length - 1

  const isDocumentStep =
    stepInfo?.id === constants.supplierJourney.DOCUMENT_STEP_ID

  const isTwoFactorAuthenticationStep =
    stepInfo?.id === constants.supplierJourney.TWO_FACTOR_AUTHENTICATION_STEP_ID

  const COMPONENTS_STEPS = [
    DocumentStep,
    EmailStep,
    TwoFactorAuthenticationStep,
  ]
  const StepComponent = COMPONENTS_STEPS[activeStep]

  const SKELETONS_STEPS = [
    DocumentStepSkeleton,
    EmailStepSkeleton,
    TwoFactorAuthenticationStepSkeleton,
  ]
  const SkeletonComponent = SKELETONS_STEPS[activeStep]

  const mixpanelNextStep = () => {
    helpers.mixpanel.track('Jornada Fornecedores', 'Avançando etapa', {
      action: `avancar_${stepInfo?.stepMixpanel}`,
    })
  }

  useEffect(() => {
    loadDataWithAnimation(token, slug)

    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (isEmpty(steps)) {
      setSteps(constants.supplierJourney.STEPS(company?.name || ''))
    }
    setStepInfo(
      constants.supplierJourney.STEPS(isFirstAccess || '')[activeStep],
    )
    //eslint-disable-next-line
  }, [activeStep])

  useEffect(() => {
    if (loaded && isFirstAccess) {
      reset({
        name: supplier?.name || '',
      })
    }
    // eslint-disable-next-line
  }, [loaded])

  useEffect(() => {
    setNextDisabled(
      (isTwoFactorAuthenticationStep && !recaptcha) ||
        (isDocumentStep && !recaptcha),
    )
    // eslint-disable-next-line
  }, [isTwoFactorAuthenticationStep, isDocumentStep, recaptcha])

  return (
    <Box
      display="flex"
      height="100vh"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box width="100%" px={5} mb={2}>
        {linkInvalid ? (
          <InvalidLinkScreen />
        ) : (
          <>
            <FormContext {...formMethods}>
              {loaded ? <StepComponent /> : <SkeletonComponent />}
            </FormContext>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={8}>
                <Box
                  py={isFinalStep ? 0 : 4}
                  display="flex"
                  justifyContent="flex-end"
                  mt={2}
                >
                  <Button
                    type="submit"
                    form="form-register"
                    variant="contained"
                    color="primary"
                    disabled={nextDisabled}
                    onClick={mixpanelNextStep}
                    style={{ padding: '8px 16px', minWidth: 120 }}
                  >
                    {isFinalStep ? 'Acessar' : 'Avançar'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      </Box>
    </Box>
  )
}

export default Journey
